import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminScansTodayAdapter } from './adapters/adminKpiAdapters';

export const adminScansTodayConfig: WidgetConfig = {
  id: 'admin-scans-today',
  title: 'Scans Today',
  icon: 'radar',
  category: 'statistics',
  description: 'Number of scraping jobs run today',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 5,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminScansTodayWidget() {
  const dataQuery = useAdminScansTodayAdapter();

  return (
    <SharedKPIWidget
      config={adminScansTodayConfig}
      dataQuery={dataQuery}
      color="warning"
    />
  );
}
